<script setup lang="ts">
import { ref } from "vue";
import User from "../models/User.ts";

const props = defineProps<{
  user: User;
}>();

const userInfoDialog = ref<boolean>()

</script>

<template>
  <v-avatar v-if="!user || user && !user.last_name || user && !user.first_name"
    color="primary"><v-icon>mdi-account</v-icon></v-avatar>
  <v-avatar v-else-if="user && user.user_icon === null"
    :color="User.avatarColor(user.last_name)"><v-icon>mdi-account</v-icon></v-avatar>
  <v-avatar @click="userInfoDialog = true" v-else-if="user && user.user_icon !== 'icons/user_icon.svg'"
    :image="user.user_icon"></v-avatar>
  <v-avatar @click="userInfoDialog = true" v-else :color="User.avatarColor(user.last_name)">{{
    user.fullName
    }}</v-avatar>
  <!-- <v-avatar v-if="!user || user && !user.last_name || user && !user.first_name" color="primary"><v-icon>mdi-account</v-icon></v-avatar>
  <v-avatar v-else-if="user && user.user_icon === null" :color="getAvatarColor(user.last_name)">{{
    user.first_name[0] + user.last_name[0]
  }}</v-avatar>
  <v-avatar @click="userInfoDialog = true" v-else-if="user && user.user_icon !== 'icons/user_icon.svg'"
    :image="user.user_icon"></v-avatar>
  <v-avatar @click="userInfoDialog = true" v-else :color="getAvatarColor(user.last_name)">{{
    user.first_name[0] + user.last_name[0]
  }}</v-avatar> -->

  <!-- <v-dialog width="auto" v-model="userInfoDialog">
    <v-card>
      <v-card-title class="d-flex justify-center align-center">
        <v-avatar v-if="user && user.user_icon !== 'icons/user_icon.svg'" size="150">
          <v-img :src="user.user_icon"></v-img>
        </v-avatar>
        <v-avatar v-else :color="getAvatarColor(user.last_name)" size="150">{{
          user.first_name[0] + user.last_name[0]
        }}</v-avatar>
      </v-card-title>
    </v-card>
  </v-dialog> -->
</template>
